module.exports = __webpack_public_path__ + "03_long_brown.03916e86.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/03_long_brown.png
// module id = 2nzE
// module chunks = 0